import React, { useEffect } from 'react';
import { Box, Grid2 } from '@mui/material';
import {
  CustomDialog,
  CustomDialogActions,
  CustomDialogContent,
  CustomTypography,
} from '@qler-view/shared_lib/src';
import CustomButton from '@qler-view/shared_lib/src/shared/lib/ui-components/Button/CustomButton';
import {
  initAudio,
  playAlert,
  stopAlert,
} from './../../shared/lib/utils/audioManager';
import AlertSound from '@assets/ringtone.mp3';

export interface ConfirmationPopupProps {
  openPopup: boolean;
  onClosePopup: () => void;
  title: string;
  message: string;
  onConfirm: () => void;
  isAudioRequired?: boolean;
}

const ConfirmationPopup: React.FC<ConfirmationPopupProps> = ({
  openPopup,
  onClosePopup,
  title,
  message,
  onConfirm,
  isAudioRequired,
}) => {
  useEffect(() => {
    if (openPopup && isAudioRequired) {
      initAudio(AlertSound);
      playAlert();
    } else {
      stopAlert();
    }
  }, [openPopup, isAudioRequired]);

  return (
    <Box>
      <CustomDialog
        id="confirmation-dialog"
        open={openPopup}
        onClose={(reason) => {
          if (reason === 'backdropClick') {
            return;
          }
          onClosePopup();
        }}
        disableEscapeKeyDown={true}
      >
        <CustomDialogContent className="dialog-width">
          <Box className="pb-6">
            <CustomTypography id="confirmation-title-popup" variant="subtitle1">
              {title}
            </CustomTypography>
          </Box>
          <Box>
            <CustomTypography id="confirmation-title-popup" variant="body3">
              {message}
            </CustomTypography>
          </Box>
        </CustomDialogContent>

        <CustomDialogActions>
          {!isAudioRequired && (
            <Grid2 container>
              <Grid2 className="mr-8">
                <CustomButton
                  id="btnYes"
                  color="primary"
                  variant="outlined"
                  onClick={() => {
                    onClosePopup();
                  }}
                >
                  Cancel
                </CustomButton>
              </Grid2>
              <Grid2>
                <CustomButton
                  id="confirmation-confirm"
                  color="primary"
                  variant="contained"
                  onClick={() => {
                    onConfirm();
                  }}
                >
                  Confirm
                </CustomButton>
              </Grid2>
            </Grid2>
          )}
          {isAudioRequired && (
            <Box>
              <CustomButton
                id="confirmation-confirm"
                color="primary"
                variant="contained"
                onClick={() => {
                  stopAlert();
                  onConfirm();
                }}
                className="btn-style"
              >
                Join
              </CustomButton>
            </Box>
          )}
        </CustomDialogActions>
      </CustomDialog>
    </Box>
  );
};

export default ConfirmationPopup;
